/**
 * 统一客户端日志打印插件,
 * @example
 *  logger.info('字符串消息');
 *  logger.info('系统消息', '字符串');
 *  logger.info('系统消息', {a: 1, b: 2});
 *  logger.info('系统消息', '多条消息', {a: 1, b: 2}, {c: 3, d: 4});
 */
import Vue from 'vue';
import { platWindow, isServerRender, isNative } from '@/utils/env';

// 用来调用客户端log函数的对象
let nativeLogger = {
  debug: () => {},
  info: () => {},
  warn: () => {},
  error: () => {},
};

const serverLogger = {
  log: (...data) => {
    console.log(formatLoggerMsg(data));
  },
  debug: (...data) => {
    console.debug(formatLoggerMsg(data));
  },
  info: (...data) => {
    console.info(formatLoggerMsg(data));
  },
  warn: (...data) => {
    console.warn(formatLoggerMsg(data));
  },
  error: (...data) => {
    console.error(formatLoggerMsg(data));
  },
};

function formatLoggerMsg(msg) {
  const data = (msg || []).map((item) => {
    let text = '';
    if ((item instanceof Error) && item.stack) {
      text = item.stack;
    } else {
      try {
        text = JSON.stringify(item);
      } catch (e) {
        //
      }
    }
    return String(text) || '';
  }, []);

  if (data.length > 1) {
    return `[H5LOG]${data[0]} ${data.slice(1).join(' ')}`;
  }
  return `[H5LOG]${data[0]}`;
}

if (isNative) {
  nativeLogger = {
    debug: (...msg) => {
      // console.log(...msg);
      invokeNativeLoggerMethod(0, msg);
    },
    info: (...msg) => {
      // console.info(...msg);
      invokeNativeLoggerMethod(1, msg);
    },
    warn: (...msg) => {
      // console.warn(...msg);
      invokeNativeLoggerMethod(2, msg);
    },
    error: (...msg) => {
      // console.error(...msg);
      invokeNativeLoggerMethod(3, msg);
    },
  };
}

function invokeNativeLoggerMethod(level, msg) {
  console.log(`[HIPPY_LOG ${level}]`, ...msg);

  const data = (msg || []).map((item) => {
    let text = '';
    if ((item instanceof Error) && item.stack) {
      text = item.stack;
    } else {
      try {
        text = JSON.stringify(item);
      } catch (e) {
        //
      }
    }
    return String(text) || '';
  }, []);

  if (data.length > 1) {
    Vue.Native.callNative('GameCommunityJsModule', 'log', level, data[0], data.slice(1).join(' '));
  } else {
    Vue.Native.callNative('GameCommunityJsModule', 'log', level, '', data.join(' '));
  }
}

const _console = isServerRender ? serverLogger : (isNative ? nativeLogger : (platWindow.console || console));

if (!isNative) { // web端添加debug方式为log
  _console.debug = _console.log;
}

const log = _console.log || (() => { });

// 可兼容一些web方法，折叠方法主要用于调试
export const logger = {
  ..._console,
  groupCollapsed: _console.groupCollapsed || log,
  table: _console.table || log,
  groupEnd: _console.groupEnd || log,
};

export default logger;
